import axios from "axios";

export const paymentIntentRequest = async (
  cartItems,
  paymentIntentId,
  discountCode = null,
  testMode
) => {
  console.log("Test mode in PI Request? " + testMode);
  try {
    let cartData = { cartItems: cartItems, discountCode: discountCode };
    let baseUrl = testMode ? "test-payment" : "payment";
    let endUrl = paymentIntentId
      ? `update-payment-intent/${paymentIntentId}`
      : "create-payment-intent";
    let completeUrl = `/api/${baseUrl}/${endUrl}`;

    let res = await axios.post(completeUrl, cartData, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data;
  } catch (err) {
    console.log(err);
  }

  // const createPaymentIntent = async (cartItems) => {
  //   try {
  //     let res = await axios.post(
  //       "/api/payment/create-payment-intent",
  //       cartItems,
  //       {
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     );
  //     setStripeClientSecret(res.data.stripeClientSecret);
  //     setOrderAttemptDetails(res.data.orderDetails);
  //     setCheckoutLoading(false);
  //   } catch (err) {
  //     console.log("An error is going down!");
  //     setCheckoutError(err);
  //     setCheckoutLoading(false);
  //   }
  // };
};
